export const ERRORS = {
  couldNotUpdateSelectedTeams: 'Could not update selected teams',
  couldNotUnpinIssue: 'Could not unpin issue',
  couldNotReorderPinnedIssues: 'Could not reorder pinned issues',
  updateIconAndColorError: 'Unable to update icon or color.',
}
